import React, { FC } from "react";
import Modal from "react-modal";
import qs from "query-string";
import { isMobile, isProduction } from "../../../util";
import { useCountryShort } from "@/hooks";
import crossIcon from "../../../images/cross_black_icon.svg";
import "./style.scss";

export type TamaraInfoModalType = {
  modalOpen: boolean;
  onRequestClose: () => void;
  language: string;
};

const style = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: isMobile.any() ? "90%" : "37%",
    height: "65%",
    overflow: "hidden",
    padding: 0
  }
};

const TAMARA_BASE_URL = isProduction()
  ? "https://cdn.tamara.co"
  : "https://cdn-sandbox.tamara.co";

const TAMARA_PUBLIC_KEY = process.env.REACT_APP_TAMARA_WIDGET_PUBLIC_KEY;

const tamaraWidgetIframeUrl = `${TAMARA_BASE_URL}/widget-v2/tamara-widget.html`;

export const TamaraInfoModal: FC<TamaraInfoModalType> = ({
  modalOpen,
  onRequestClose,
  language
}) => {
  const country = useCountryShort();
  const src = qs.stringifyUrl({
    url: tamaraWidgetIframeUrl,
    query: {
      lang: language,
      country,
      public_key: TAMARA_PUBLIC_KEY
    }
  });

  return (
    <Modal
      isOpen={modalOpen}
      style={style}
      onRequestClose={onRequestClose}
      id="tamara-info-modal"
    >
      <img
        src={crossIcon}
        alt="cross-icon"
        className="cross-icon"
        onClick={onRequestClose}
      />
      <iframe
        width="100%"
        height="100%"
        src={src}
        style={{ border: "none", position: "relative" }}
      />
    </Modal>
  );
};
